<template>
    <section>
        <b-modal v-model="open" :title="transmitterTitle" ref="modal" id="modal-transmitter-edit">
            <vue-form-generator ref="transmitterEdit" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.save')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import axios from 'axios'
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'
    import _ from 'lodash'

    export default {
        name: 'edit-transmitter',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                item: false,
                model: {
                    id: null,
                    name: null,
                    transmitter: null,
                    pulse: 1,
                    correction_1: '0',
                    type_1: 'cold',
                    label_1: '',
                    seal_1: '',
                    hide_1: false,
                    correction_2: '0',
                    type_2: 'hot',
                    label_2: '',
                    seal_2: '',
                    hide_2: false,
                    koeficient_polohy: '',
                    koeficient_svetove_strany: '',
                    pricePerUnit: 'true-1',
                    open_1: false,
                    open_2: false,
                    type: 1
                },
                schema: {
                    groups: [{
                        i18n: {
                            legend: 'message.transmitter'
                        },
                        fields: [{
                            type: 'input',
                            inputType: 'hidden',
                            model: 'id'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: this.$t('message.name'),
                            i18n: {
                                label: 'message.name',
                                placeholder: 'message.transmitter_name_placeholder'
                            },
                            model: 'name',
                            placeholder: this.$t('message.transmitter_name_placeholder'),
                            featured: true,
                            required: true,
                            validator: VueFormGenerator.validators.string
                        },{
                            type: 'select',
                            i18n: {
                                label: 'message.measurement'
                            },
                            values: [{
                                id: 1,
                                name: this.$t('message.water')
                            }, {
                                id: 2,
                                name: this.$t('message.electricity')
                            }, {
                                id: 3,
                                name: this.$t('message.gas')
                            }, {
                                id: 4,
                                name: this.$t('message.heat')
                            }],
                            required: true,
                            model: 'type'
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            unitText: () => 'pulsů',
                            i18n: {
                                label: () => this.$t('message.pulse_count_kwh')
                            },
                            visible () {
                                return this.model.type === 2
                            },
                            model: 'pulse',
                            featured: true,
                            required: true,
                            pattern: /[0-9,.]+/g,
                            hint: 'Zadaná hodnota není platné číslo.',
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            unitText: () => 'l',
                            i18n: {
                                label: () => this.$t('message.pulse_count_l')
                            },
                            visible () {
                                return this.model.type === 1
                            },
                            model: 'pulse',
                            featured: true,
                            required: true,
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }]
                    }, {
                        i18n: {
                            legend: () => this.$t('message.water_blue')
                        },
                        disabled () {
                            return this.model.type !== 1
                        },
                        fields: [{
                            type: 'checkbox',
                            i18n: {
                                label: () => this.$t('message.water_blue') + ' ' + this.$t('message.not_used')
                            },
                            model: 'hide_1',
                            isChecked: 'hide_2',
                            validator: [this.isCheckedValidator2]
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            visible: () => !this.model.hide_1,
                            i18n: {
                                label: 'message.correction_water'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_1',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.watermeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            disabled: () => this.model.hide_1,
                            label: '',
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'select',
                            i18n: {
                                label: 'message.type'
                            },
                            disabled: () => this.model.hide_1,
                            model: 'type_1',
                            required: true,
                            values: [{
                                id: 'hot',
                                i18n: {
                                    name: 'message.hot_water'
                                }
                            }, {
                                id: 'cold',
                                i18n: {
                                    name: 'message.cold_water'
                                }
                            }],
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.price_estimate_water',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            model: 'pricePerLiterCold',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    }, {
                        legend: this.$t('message.electricity_meter'),
                        i18n: {
                            legend: () => this.$t('message.electricity_meter')
                        },
                        disabled () {
                            return this.model.type !== 2
                        },
                        fields: [{
                            type: 'inputUnit',
                            inputType: 'text',
                            i18n: {
                                label: 'message.correction_power'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "kWh" },
                                    { value: 1, label: "Wh" },
                                ]
                            },
                            model: 'correction_1',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.powermeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            i18n: {
                                label: 'message.price_estimate_power',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            disabled: () => this.model.hide_1,
                            model: 'pricePerLiterCold',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    },
                        {
                            legend: this.$t('message.gas_meter'),
                            i18n: {
                                legend: () => this.$t('message.gas_meter')
                            },
                            disabled () {
                                return this.model.type !== 3
                            },
                            fields: [{
                                type: 'inputUnit',
                                inputType: 'text',
                                i18n: {
                                    label: 'message.correction_gas'
                                },
                                units: () => {
                                    return [
                                        { value: 1000, label: "m3" },
                                        { value: 1, label: "l" },
                                    ]
                                },
                                model: 'correction_1',
                                pattern: /[0-9,.]+/g,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                disabled: () => this.model.hide_1,
                                i18n: {
                                    label: 'message.gasmeter_label'
                                },
                                model: 'label_1'
                            }, {
                                type: 'collapseOptions',
                                i18n: {
                                    textValue: 'message.advanced_settings'
                                },
                                model: 'open_1'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                disabled: () => this.model.hide_1,
                                i18n: {
                                    label: 'message.seal_number'
                                },
                                model: 'seal_1',
                                visible () {
                                    return this.model.open_1
                                }
                            }, {
                                type: 'checkboxText',
                                i18n: {
                                    label: 'message.price_estimate_power',
                                    checkboxLabel: 'message.from_parent_object',
                                    unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                                },
                                disabled: () => this.model.hide_1,
                                model: 'pricePerLiterCold',
                                pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                                validator: [VueFormGenerator.validators.regexp],
                                visible () {
                                    return this.model.open_1
                                }
                            }]
                        },
                        {
                            legend: this.$t('message.heat_meter'),
                            i18n: {
                                legend: () => this.$t('message.heat_meter')
                            },
                            disabled () {
                                return this.model.type !== 4
                            },
                            fields: [{
                                type: 'inputUnit',
                                inputType: 'text',
                                i18n: {
                                    label: 'message.correction_heat'
                                },
                                units: () => {
                                    return [
                                        { value: 1, label: "" },
                                    ]
                                },
                                model: 'correction_1',
                                pattern: /[0-9,.]+/g,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                i18n: {
                                    label: 'message.koeficient_polohy'
                                },
                                model: 'koeficient_polohy',
                                pattern: /[0-9,.]+/g,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                i18n: {
                                    label: 'message.koeficient_svetove_strany'
                                },
                                model: 'koeficient_svetove_strany',
                                pattern: /[0-9,.]+/g,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                disabled: () => this.model.hide_1,
                                i18n: {
                                    label: 'message.heatmeter_label'
                                },
                                model: 'label_1'
                            }, {
                                type: 'collapseOptions',
                                i18n: {
                                    textValue: 'message.advanced_settings'
                                },
                                model: 'open_1'
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: '',
                                disabled: () => this.model.hide_1,
                                i18n: {
                                    label: 'message.seal_number'
                                },
                                model: 'seal_1',
                                visible () {
                                    return this.model.open_1
                                }
                            }, {
                                type: 'checkboxText',
                                i18n: {
                                    label: 'message.price_estimate_heat',
                                    checkboxLabel: 'message.from_parent_object',
                                    unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                                },
                                disabled: () => this.model.hide_1,
                                model: 'pricePerUnit',
                                pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                                validator: [VueFormGenerator.validators.regexp],
                                visible () {
                                    return this.model.open_1
                                }
                            }]
                        }, {
                        i18n: {
                            legend: () => this.$t('message.water_red')
                        },
                        disabled () {
                            return this.model.type !== 1
                        },
                        fields: [{
                            type: 'checkbox',
                            i18n: {
                                label: () => this.$t('message.water_red') + ' ' + this.$t('message.not_used')
                            },
                            model: 'hide_2',
                            isChecked: 'hide_1',
                            validator: [this.isCheckedValidator2]
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            visible: () => !this.model.hide_2,
                            i18n: {
                                label: 'message.correction_water'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_2',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            disabled: () => this.model.hide_2,
                            i18n: {
                                label: 'message.watermeter_label'
                            },
                            model: 'label_2'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_2'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            disabled: () => this.model.hide_2,
                            label: '',
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_2',
                            visible () {
                                return this.model.open_2
                            }
                        }, {
                            type: 'select',
                            i18n: {
                                label: 'message.type'
                            },
                            disabled: () => this.model.hide_2,
                            model: 'type_2',
                            required: true,
                            values: [{
                                id: 'hot',
                                name: this.$t('message.hot_water'),
                                i18n: {
                                    name: 'message.hot_water'
                                }
                            }, {
                                id: 'cold',
                                name: this.$t('message.cold_water'),
                                i18n: {
                                    name: 'message.cold_water'
                                }
                            }],
                            visible () {
                                return this.model.open_2
                            }
                        }, {
                            type: 'checkboxText',
                            disabled: () => this.model.hide_2,
                            i18n: {
                                label: 'message.price_estimate_water',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            model: 'pricePerLiterHot',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_2
                            }
                        }]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        computed: {
            transmitterTitle () {
                let serialNumber = this.model.transmitter
                if (Number(this.model.type) === 4) {
                    const decoded = this.decodeITN(serialNumber)
                    if (decoded !== null) {
                        serialNumber = decoded
                    }
                }
                return this.$t('message.edit_transmitter') + ' - ' + (serialNumber || '')
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.transmitterEdit.validate()
                if (this.isValid) {
                    const data = _.cloneDeep(this.model)
                    let m = 1
                    if (data.type === 4) {
                        data.medium = 'heat'
                        m = 1000
                    } else if (data.type === 3) {
                        data.medium = 'gas'
                    } else if (data.type === 2) {
                        data.medium = 'power'
                        m = 1000
                    } else {
                        data.medium = 'water'
                    }
                    data.pulse = data.pulse * m
                    axios.post(`/api/v1/edit-entity/${this.item.id}?type=${this.item.type}`, data)
                        .then(response => {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'edit-transmitter'})
                        }) // TODO catch ERROR
                }
            },
            show (item) {
                this.item = item
                axios.get(`/api/v1/entity/${item.id}?type=${item.type}`).then(response => {
                    const data = response.data.data
                    data.type = Number(data.type)
                    let m = 1;
                    if (data.type === 4) {
                        data.medium = 'heat'
                        m = 1000
                    } else if (data.type === 3) {
                        data.medium = 'gas'
                    } else if (data.type === 2) {
                        data.medium = 'power'
                        m = 1000
                    } else {
                        data.medium = 'water'
                    }
                    data.pulse = '' + data.pulse / m
                    data.correction_1 = '' + data.correction_1
                    data.correction_2 = '' + data.correction_2
                    data.koeficient_polohy = data.koeficient_polohy != null ? '' + data.koeficient_polohy : ''
                    data.koeficient_svetove_strany = data.koeficient_svetove_strany != null ? '' + data.koeficient_svetove_strany : ''
                    this.model = data
                })
                this.open = true
            }
        }
    }
</script>

<style scoped>

</style>
